import {
	UPDATE_NOTIFICATIONS,
	CLEAR_NOTIFICATIONS,
	FILTER_NOTIFICATIONS,
	NEW_NOTIFICATION,
	PAYMENT_REQUIRED,
} from '../actions/types';
import { updateObject } from './utils/globalStateFunctions';

const INITIAL_STATE = {
	/** null — not `{}` (empty object is truthy and made the collapsed notification bar show a fake "New notification"). */
	lastNotification: null,
	filteredNotifications: [],
	count: 0,
};

const notificationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case PAYMENT_REQUIRED:
			return updateObject(state, {
				lastNotification: action.payload,
				count: state.count + 1,
			});
		case NEW_NOTIFICATION:
			return updateObject(state, {
				lastNotification: action.payload,
				count: state.count + 1,
			});
		case UPDATE_NOTIFICATIONS:
			return updateObject(state, {
				lastNotification: action.payload && action.payload.length > 0 ? action.payload[0] : state.lastNotification,
				count: action.payload.length,
			});
		case CLEAR_NOTIFICATIONS:
			return updateObject(state, {
				count: 0,
			});
		case FILTER_NOTIFICATIONS:
			return updateObject(state, {
				filteredNotifications: action.payload,
			});
		default:
			return state;
	}
};

export default notificationReducer;
